import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../services/supabaseClient'

export default function ResetPassword() {
  const navigate = useNavigate()
  const [ready, setReady] = useState(false)
  const [password, setPassword] = useState('')
  const [password2, setPassword2] = useState('')
  const [error, setError] = useState('')
  const [ok, setOk] = useState('')
  const [working, setWorking] = useState(false)

  useEffect(() => {
    let unsub = null
    ;(async () => {
      const { data } = await supabase.auth.getSession()
      if (data.session) {
        setReady(true)
      }
      const _sub = supabase.auth.onAuthStateChange((event, session) => {
        if (event === 'PASSWORD_RECOVERY' || session) {
          setReady(true)
        }
      })
      unsub = () => _sub.data.subscription.unsubscribe()
    })()
    return () => { if (unsub) unsub() }
  }, [])

  const onSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setOk('')
    if (password.length < 6) { setError('الحد الأدنى لطول كلمة المرور هو 6 أحرف'); return }
    if (password !== password2) { setError('كلمتا المرور غير متطابقتين'); return }

    setWorking(true)
    try {
      const { error } = await supabase.auth.updateUser({ password })
      if (error) throw error
      setOk('تم تحديث كلمة المرور بنجاح. جاري تحويلك إلى تسجيل الدخول...')
      setTimeout(() => navigate('/login', { replace: true }), 1200)
    } catch (e) {
      setError(e.message || 'فشل تحديث كلمة المرور')
    } finally {
      setWorking(false)
    }
  }

  return (
    <div dir="rtl" style={{ maxWidth: 380, margin: '4rem auto', padding: 24, border: '1px solid #ddd', borderRadius: 8 }}>
      <h2 style={{ textAlign: 'center' }}>إعادة تعيين كلمة المرور</h2>
      {!ready ? (
        <div style={{ textAlign: 'center', marginTop: 16 }}>يرجى الانتظار للحظات...</div>
      ) : (
        <form onSubmit={onSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <input type="password" placeholder="كلمة المرور الجديدة" value={password} onChange={e => setPassword(e.target.value)} required />
          <input type="password" placeholder="تأكيد كلمة المرور" value={password2} onChange={e => setPassword2(e.target.value)} required />
          {error && <div style={{ color: 'red', textAlign: 'right' }}>{error}</div>}
          {ok && <div style={{ color: 'green', textAlign: 'right' }}>{ok}</div>}
          <button type="submit" disabled={working}>{working ? 'جاري الحفظ...' : 'حفظ كلمة المرور'}</button>
        </form>
      )}
    </div>
  )
}
